import { ApiService } from '../../../../core/store/base/api-service';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../../../../core/services/api.service";
export class FeatureService extends ApiService {
    constructor() {
        super(...arguments);
        this.apiSegment = 'brand-prodotti';
    }
    /**
     * L'endpoint brand usa una API Resource, quindi risponde {"data": [...]},
     * a differenza degli endpoint legacy che restituiscono l'array nudo.
     */
    all() {
        return super.all().pipe(map((response) => response.data));
    }
}
FeatureService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FeatureService_Factory() { return new FeatureService(i0.ɵɵinject(i1.ApiClient)); }, token: FeatureService, providedIn: "root" });
